import { Component, OnInit } from '@angular/core';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { FormConfiguration } from 'src/app/core/components/dynamic-form/models/form-config';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { FileManagerService } from 'src/app/core/components/upload-tool/services/file-manager.service';
import { DocumentElaboration, FilesList } from 'src/app/core/models/files';
import { DocumentManagementService } from '../../services/document-management.service';
import { uploadFormConfiguration } from './config/upload-form-configuration';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';

@Component({
  selector: 'app-upload-panel',
  templateUrl: './upload-panel.component.html',
  styleUrls: ['./upload-panel.component.css']
})
export class UploadPanelComponent implements OnInit {
  uploadedFile: FilesList
  formFields: QuestionBase[] = []
  formConfiguration: FormConfiguration = {
    buttons: [
      {
        bg: "",
        width: "",
        type: "submit",
        title: "Invia Elaborazione",
        class: "btn-primary",
      },
      {
        bg: "",
        width: "",
        type: "reset",
        title: "Reset",
        class: "btn-secondary",
      }
    ]
  }
  constructor(
    public config: DialogConfig,
    private dialog: DialogRef,
    private fileManager: FileManagerService,
    private documentManager: DocumentManagementService,
    private modalNotifyService: ModalNotifyService
  ) { }

  ngOnInit() {
    const formFields = uploadFormConfiguration
    this.formFields = this.formFieldConfiguration(formFields)
    this.uploadedFile = this.config.data.file
  }

  private formFieldConfiguration(fields: QuestionBase[]): QuestionBase[] {
    const indexTipo = fields.findIndex(el => el.key === "tipoDocumento")
    const indexProvenienza = fields.findIndex(el => el.key === "provenienza")
    this.elementMapper(fields, indexTipo, "tipiDocumento");
    this.elementMapper(fields, indexProvenienza, "tipiProvenienzaDocumento");
    return fields
  }

  private elementMapper(fields: QuestionBase[], indexTipo: number, element: string) {
    fields[indexTipo].options = this.config.data.options[element].map(el => {
      return {
        key: el.id,
        value: el.label,
        label: el.label
      };
    });
  }

  sendFileElaboration(event) {
    let elaboration: DocumentElaboration = {}
    elaboration.idTipoDocumento = event.tipoDocumento;
    elaboration.idProvenienza = event.provenienza;
    elaboration.titolo = event.titolo;
    elaboration.dataRiferimento = event.dataRiferimento;
    elaboration.refDocumentale = this.uploadedFile.refDocumentale;
    this.documentManager.sendDocumentElaboration({documenti: [elaboration]}).subscribe(
      elaborations => {
        this.dialog.close(elaborations);
        this.modalNotifyService.customMessage("Documento inviato per l'elaborazione");
        this.updateFileList();
      }
    )
  }


  private updateFileList() {
    let fileListAsIs;
    this.fileManager.filesList.subscribe(files => {
      fileListAsIs = files;
    });
    const index = fileListAsIs.findIndex(itm => itm.name === this.uploadedFile.name);
    fileListAsIs.splice(index, 1);
    this.fileManager.updateFilesList(fileListAsIs);
  }
}
